<ng-container>
	<div data-testid="sh-confirm-dialog" cdkTrapFocus>
		@if (!!data.title) {
			<h2 class="sh-confirm-dialog-title" data-testid="sh-confirm-dialog-title" mat-dialog-title>
				@if (data.showIcon) {
					<prism-icon
						class="sh-warning-icon"
						[class.sh-info-icon]="data.showIcon === showIcon.Info"
						[icon]="data.showIcon === showIcon.Warning ? 'sh-warning-outline' : 'mdo-info'"
					>
					</prism-icon>
				}
				{{ data.title }}
			</h2>
		}

		<div fxLayoutGap="10px" class="sh-content-actions-container">
			<mat-dialog-content>
				<div fxLayout="column" fxLayoutGap="20px">
					@if (data.body) {
						@for (line of data.body; track line; let i = $index) {
							<span>
								@if (isTextObject(line)) {
									<prism-icon
										class="sh-body-icon"
										[class.sh-info-icon]="data.showIcon === showIcon.Info"
										[icon]="line.icon"
									>
									</prism-icon>
									<span class="mat-body-2" [innerHtml]="line.text"></span>
								} @else {
									<span class="mat-body-2" [innerHtml]="line"></span>
								}
							</span>
						}
					}
					@if (data.doNotShowDialogId) {
						<span *transloco="let t; prefix: 'scConfirmDialog'"
							><prism-checkbox
								id="sh-confirm-dialog-do-not-show"
								data-testid="sh-confirm-dialog-do-not-show"
								(valueChange)="toggleDoNotShowDialog($event.detail)"
								[checked]="doNotShowDialog"
							>
								{{ t('no-show-dialog-again') }}
							</prism-checkbox></span
						>
					}
				</div>
			</mat-dialog-content>

			<mat-dialog-actions fxLayout="row" fxLayoutAlign="end end" fxLayoutGap="10px">
				<prism-button
					id="sh-confirm-dialog-cancel-button"
					data-testid="sh-confirm-dialog-cancel-button"
					(click)="closeDialog({ confirmed: false, doNotShowDialog: false })"
				>
					{{ data.cancelLabel }}
				</prism-button>
				<prism-button
					cdkFocusInitial
					(click)="closeDialog({ confirmed: true, doNotShowDialog })"
					id="sh-confirm-dialog-confirm-button"
					data-testid="sh-confirm-dialog-confirm-button"
				>
					{{ data.confirmLabel }}
				</prism-button>
			</mat-dialog-actions>
		</div>
	</div>
</ng-container>
